import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';
import { QuicksourceDownloadsComponent } from 'src/app/shared-components/quicksource-downloads/quicksource-downloads.component';

import config from '../../config/config';
import { AdminAdminComponent } from './admin/admin-admin/admin-admin.component';
import { AdminAdminClientApConfigsComponent } from './admin/admin-admin/client-ap-configs/admin-admin-client-ap-configs.component';
import { AdminAdminEmailsComponent } from './admin/admin-admin/emails/admin-admin-emails.component';
import { AdminAdminEsignTemplatesComponent } from './admin/admin-admin/esign-templates/admin-admin-esign-templates.component';
import { AdminAdminSsoConnectionsComponent } from './admin/admin-admin/sso-connections/admin-admin-sso-connections.component';
import { AdminAdminSsoConnectionComponent } from './admin/admin-admin/sso-connections/sso-connection/admin-admin-sso-connection.component';
import { AdminAdminTradesComponent } from './admin/admin-admin/trades/admin-admin-trades.component';
import { AdminComponent } from './admin/admin.component';
import { AddClientComponent } from './admin/clients/add-client/add-client.component';
import { AdminClientAdminComponent } from './admin/clients/admin-client/admin-client-admin/admin-client-admin.component';
import { AdminClientApConfigsComponent } from './admin/clients/admin-client/admin-client-ap-configs/admin-client-ap-configs.component';
import { AdminClientClientRegisteredVendorsComponent } from './admin/clients/admin-client/admin-client-client-registered-vendors/admin-client-client-registered-vendors.component';
import { AdminClientExemptVendorsComponent } from './admin/clients/admin-client/admin-client-exempt-vendors/admin-client-exempt-vendors.component';
import { AdminClientNotesComponent } from './admin/clients/admin-client/admin-client-notes/admin-client-notes.component';
import { AdminClientServiceRegionsComponent } from './admin/clients/admin-client/admin-client-service-regions/admin-client-service-regions.component';
import { AdminClientSitesComponent } from './admin/clients/admin-client/admin-client-sites/admin-client-sites.component';
import { AdminClientVendorsComponent } from './admin/clients/admin-client/admin-client-vendors/admin-client-vendors.component';
import { AdminClientComponent } from './admin/clients/admin-client/admin-client.component';
import { ClientInfoComponent } from './admin/clients/admin-client/client-info/client-info.component';
import { ComplianceSettingsComponent } from './admin/clients/admin-client/compliance-settings/compliance-settings.component';
import { ClientsComponent } from './admin/clients/clients.component';
import { AdminComplianceClientRegisteredVendorsComponent } from './admin/compliance/client-registered-vendors/admin-compliance-client-registered-vendors.component';
import { ComplianceBusinessReviewComponent } from './admin/compliance/compliance-review/compliance-business-review/compliance-business-review.component';
import { ComplianceFinalReviewComponent } from './admin/compliance/compliance-review/compliance-final-review/compliance-final-review.component';
import { AddEditCOIComponent } from './admin/compliance/compliance-review/compliance-insurance-review/add-edit-coi/add-edit-coi.component';
import { ComplianceInsuranceReviewComponent } from './admin/compliance/compliance-review/compliance-insurance-review/compliance-insurance-review.component';
import { ComplianceOwnerReviewComponent } from './admin/compliance/compliance-review/compliance-owner-review/compliance-owner-review.component';
import { ComplianceReviewComponent } from './admin/compliance/compliance-review/compliance-review.component';
import { ComplianceTradeReviewComponent } from './admin/compliance/compliance-review/compliance-trade-review/compliance-trade-review.component';
import { ComplianceComponent } from './admin/compliance/compliance.component';
import { AdminComplianceExemptVendorComponent } from './admin/compliance/exempt-vendors/admin-compliance-exempt-vendor.component';
import { AdminDashboardComponent } from './admin/dashboard/admin-dashboard/admin-dashboard.component';
import { ApSystemsComponent } from './admin/dashboard/dashboard-widgets/api-errors-widget/ap-systems/ap-systems.component';
import { BusinessVerificationApiErrorsComponent } from './admin/dashboard/dashboard-widgets/api-errors-widget/business-verification-api-errors/business-verification-api-errors.component';
import { AdminDashboardsComponent } from './admin/dashboards/admin-dashboards.component';
import { NotificationCenterComponent } from './admin/notification/notification-center/notification-center.component';
import { ReportsComponent } from './admin/reports/reports.component';
import { AdminVendorAdminComponent } from './admin/vendors/admin-vendor/admin-vendor-admin/admin-vendor-admin.component';
import { AdminVendorClientsComponent } from './admin/vendors/admin-vendor/admin-vendor-clients/admin-vendor-clients.component';
import { AdminVendorContactsComponent } from './admin/vendors/admin-vendor/admin-vendor-contacts/admin-vendor-contacts.component';
import { AdminVendorDocumentsComponent } from './admin/vendors/admin-vendor/admin-vendor-documents/admin-vendor-documents.component';
import { AdminVendorInfoComponent } from './admin/vendors/admin-vendor/admin-vendor-info/admin-vendor-info.component';
import { AdminVendorInvoicesComponent } from './admin/vendors/admin-vendor/admin-vendor-invoices/admin-vendor-invoices.component';
import { AdminVendorNotesComponent } from './admin/vendors/admin-vendor/admin-vendor-notes/admin-vendor-notes.component';
import { AdminVendorOwnersComponent } from './admin/vendors/admin-vendor/admin-vendor-owners/admin-vendor-owners.component';
import { AdminVendorComponent } from './admin/vendors/admin-vendor/admin-vendor.component';
import { VendorsComponent } from './admin/vendors/vendors.component';
import { ClientAdminAccountingSystemComponent } from './client/admin/accounting/accounting-system/client-admin-accounting-system.component';
import { ClientAdminAccountingAllApVendorsComponent } from './client/admin/accounting/all-ap-vendors/client-admin-accounting-all-ap-vendors.component';
import { ClientAdminAccountingComponent } from './client/admin/accounting/client-admin-accounting.component';
import { ClientAdminComponent } from './client/admin/client-admin.component';
import { ClientAdminComplianceExemptSetupComponent } from './client/admin/compliance-exempt-setup/client-admin-compliance-exempt-setup.component';
import { ClientAdminMyCompanyComponent } from './client/admin/my-company/client-admin-my-company.component';
import { ClientAdminPublicApiKeysComponent } from './client/admin/public-api-keys/client-admin-public-api-keys.component';
import { ClientAdminSpotlightVendorsComponent } from './client/admin/spotlight-vendors/client-admin-spotlight-vendors.component';
import { ClientReportsComponent } from './client/client-reports/client-reports.component';
import { ClientComponent } from './client/client.component';
import { ContractAddContractComponent } from './client/contracts/contract/contract-add-contract/contract-add-contract.component';
import { ContractReviewComponent } from './client/contracts/contract/contract-review/contract-review.component';
import { ContractSiteSelectionComponent } from './client/contracts/contract/contract-site-selection/contract-site-selection.component';
import { ContractVendorSelectionComponent } from './client/contracts/contract/contract-vendor-selection/contract-vendor-selection.component';
import { ContractComponent } from './client/contracts/contract/contract.component';
import { ContractsComponent } from './client/contracts/contracts.component';
import { ClientDashboardComponent } from './client/dashboard/client-dashboard/client-dashboard.component';
import { QuicksourceAddVendorsComponent } from './client/quicksource/quicksource-creation/quicksource-add-vendors/quicksource-add-vendors.component';
import { QuicksourceCreationComponent } from './client/quicksource/quicksource-creation/quicksource-creation.component';
import { QuicksourceDatePricingInstructionsComponent } from './client/quicksource/quicksource-creation/quicksource-date-pricing-instructions/quicksource-date-pricing-instructions.component';
import { QuicksourceLocationAndContactComponent } from './client/quicksource/quicksource-creation/quicksource-location-and-contact/quicksource-location-and-contact.component';
import { QuicksourceReviewComponent } from './client/quicksource/quicksource-creation/quicksource-review/quicksource-review.component';
import { QuicksourceSiteSelectionComponent } from './client/quicksource/quicksource-creation/quicksource-site-selection/quicksource-site-selection.component';
import { QuicksourceComponent } from './client/quicksource/quicksource.component';
import { AddSiteComponent } from './client/sites/client-sites/add-site/add-site.component';
import { ClientSitesComponent } from './client/sites/client-sites/client-sites.component';
import { EditSiteComponent } from './client/sites/client-sites/edit-site/edit-site.component';
import { SiteAdminComponent } from './client/sites/client-sites/site/site-admin/site-admin.component';
import { SiteContactsComponent } from './client/sites/client-sites/site/site-contacts/site-contacts.component';
import { SiteDetailsComponent } from './client/sites/client-sites/site/site-details/site-details.component';
import { SiteUsersComponent } from './client/sites/client-sites/site/site-users/site-users.component';
import { SiteVendorsValidatedComponent } from './client/sites/client-sites/site/site-vendors-validated/site-vendors-validated.component';
import { SiteVendorFilesComponent } from './client/sites/client-sites/site/site-vendors/site-vendor-files/site-vendor-files.component';
import { SiteVendorsComponent } from './client/sites/client-sites/site/site-vendors/site-vendors.component';
import { SiteComponent } from './client/sites/client-sites/site/site.component';
import { SiteFilesComponent } from './client/sites/site-files/site-files.component';
import { VendorRatingsComponent } from './client/vendor-ratings/vendor-ratings.component';
import { ClientMyVendorAdminComponent } from './client/vendors/client-my-vendors/client-my-vendor/client-my-vendor-admin/client-my-vendor-admin.component';
import { ClientMyVendorContactsComponent } from './client/vendors/client-my-vendors/client-my-vendor/client-my-vendor-contacts/client-my-vendor-contacts.component';
import { ClientMyVendorContractDetailsComponent } from './client/vendors/client-my-vendors/client-my-vendor/client-my-vendor-contracts/client-my-vendor-contract-details/client-my-vendor-contract-details.component';
import { ClientMyVendorContractsComponent } from './client/vendors/client-my-vendors/client-my-vendor/client-my-vendor-contracts/client-my-vendor-contracts.component';
import { ClientMyVendorDocumentsComponent } from './client/vendors/client-my-vendors/client-my-vendor/client-my-vendor-documents/client-my-vendor-documents.component';
import { ClientMyVendorHistoryComponent } from './client/vendors/client-my-vendors/client-my-vendor/client-my-vendor-history/client-my-vendor-history.component';
import { ClientMyVendorInsuranceComponent } from './client/vendors/client-my-vendors/client-my-vendor/client-my-vendor-insurance/client-my-vendor-insurance.component';
import { ClientMyVendorQsbComponent } from './client/vendors/client-my-vendors/client-my-vendor/client-my-vendor-qsb/client-my-vendor-qsb.component';
import { ProposalRequestComponent } from './client/vendors/client-my-vendors/client-my-vendor/client-my-vendor-qsb/proposal-request/proposal-request.component';
import { ClientMyVendorRatingsComponent } from './client/vendors/client-my-vendors/client-my-vendor/client-my-vendor-ratings/client-my-vendor-ratings.component';
import { ClientMyVendorSitesComponent } from './client/vendors/client-my-vendors/client-my-vendor/client-my-vendor-sites/client-my-vendor-sites.component';
import { ClientMyVendorTradesAndLicensesComponent } from './client/vendors/client-my-vendors/client-my-vendor/client-my-vendor-trades-and-licenses/client-my-vendor-trades-and-licenses.component';
import { ClientMyVendor } from './client/vendors/client-my-vendors/client-my-vendor/client-my-vendor.component';
import { ClientVendorsComponent } from './client/vendors/client-vendors.component';
import { ClientCompanyPlaceholderGuard } from './guards/client-company-placeholder.guard';
import { LegacyVendorWizardRedirectGuard } from './guards/legacy-vendor-wizard-redirect.guard';
import { RowcalTermsGuard } from './guards/rowcal-terms.guard';
import { SessionAvailableGuard } from './guards/session-available.guard';
import { VendorPortalRedirectGuard } from './guards/vendor-portal-redirect.guard';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './login/reset-password/reset-password.component';
import { LogoutComponent } from './logout/logout.component';
import { AuthGuardService as AuthGuard } from './services/auth-guard.service';
import { SessionUnavailableComponent } from './session-unavailable/session-unavailable.component';
import { AddEditClientRegisteredVendorComponent } from './shared-components/add-edit-client-registered-vendor/add-edit-client-registered-vendor.component';
import { AddEditExemptVendorComponent } from './shared-components/add-edit-exempt-vendor/add-edit-exempt-vendor.component';
import { AppContainerComponent } from './shared-components/app-container/app-container.component';
import { ChangeLogComponent } from './shared-components/change-log/change-log.component';
import { ClientRegisteredVendorComplianceComponent } from './shared-components/client-registered-vendor-compliance/client-registered-vendor-compliance.component';
import { ClientServiceAgreementComponent } from './shared-components/client-service-agreement/client-service-agreement.component';
import { RowcalPreferredVendorTermsComponent } from './shared-components/rowcal-preferred-vendor-terms/rowcal-preferred-vendor-terms.component';
import { UserComponent } from './shared-components/users/user/user.component';
import { UsersComponent } from './shared-components/users/users.component';
import { VendorDocumentsNotesComponent } from './shared-components/vendor-documents-notes/vendor-documents-notes.component';
import { VendorInformationComponent } from './shared-components/vendor-information/vendor-information.component';
import { VendorSearchContainerComponent } from './shared-components/vendor-search-container/vendor-search-container.component';
import { VendorSiteAssignmentComponent } from './shared-components/vendor-site-assignment/vendor-site-assignment.component';
import { ProposalComponent } from './vendor/quicksource/proposals/proposal/proposal.component';
import { ProposalsComponent } from './vendor/quicksource/proposals/proposals.component';

// Used for Vendor, ExemptVendor, and ClientRegisteredVendor routes
const vendorRouteArray: Route[] = [
  {
    path: 'info',
    component: ClientMyVendor
  },
  {
    path: 'contacts',
    component: ClientMyVendorContactsComponent
  },
  {
    path: 'insurance',
    component: ClientMyVendorInsuranceComponent
  },
  {
    path: 'trades-and-licenses',
    component: ClientMyVendorTradesAndLicensesComponent
  },
  {
    path: 'sites',
    component: ClientMyVendorSitesComponent
  },
  {
    path: 'ratings',
    component: ClientMyVendorRatingsComponent
  },
  {
    path: 'contracts',
    component: ClientMyVendorContractsComponent
  },
  {
    path: 'contracts',
    children: [
      {
        path: 'contract/:ContractId',
        component: ClientMyVendorContractDetailsComponent
      }
    ]
  },
  {
    path: 'qsb',
    component: ClientMyVendorQsbComponent
  },
  {
    path: 'qsb',
    children: [
      {
        path: 'proposal-request/:ProposalRequestId',
        component: ProposalRequestComponent
      }
    ]
  },
  {
    path: 'history',
    component: ClientMyVendorHistoryComponent
  },
  {
    path: 'documents',
    component: ClientMyVendorDocumentsComponent
  },
  {
    path: 'admin',
    component: ClientMyVendorAdminComponent
  }
];

const ProposalRequestChildRoutes: Routes = [
  {
    path: 'site-selection',
    component: QuicksourceSiteSelectionComponent
  },
  {
    path: 'site/:SiteId/site-selection',
    component: QuicksourceSiteSelectionComponent
  },
  {
    path: 'location-contacts',
    component: QuicksourceLocationAndContactComponent
  },
  {
    path: 'date-pricing-instructions',
    component: QuicksourceDatePricingInstructionsComponent
  },
  {
    path: 'add-vendors',
    component: QuicksourceAddVendorsComponent
  },
  {
    path: 'review',
    component: QuicksourceReviewComponent
  },
  {
    path: '',
    redirectTo: 'site-selection',
    pathMatch: 'full'
  }
];

const AdminVendorChildRoutes = [
  {
    path: 'info',
    component: AdminVendorInfoComponent
  },
  {
    path: 'contacts',
    component: AdminVendorContactsComponent
  },
  {
    path: 'clients',
    component: AdminVendorClientsComponent
  },
  {
    path: 'owners',
    component: AdminVendorOwnersComponent
  },
  {
    path: 'invoices',
    component: AdminVendorInvoicesComponent
  },
  {
    path: 'documents',
    component: AdminVendorDocumentsComponent
  },
  {
    path: 'notes',
    component: AdminVendorNotesComponent
  },
  {
    path: 'admin',
    component: AdminVendorAdminComponent
  }
];

const guardedRoutes: Routes = [
  {
    path: '',
    component: LoginComponent,
    canActivate: [VendorPortalRedirectGuard]
  },
  {
    path: '',
    component: AppContainerComponent,
    children: [
      {
        path: 'client',
        component: ClientComponent,
        canActivate: [AuthGuard],
        children: [
          // `/client/current/<path>` resolves to the signed-in client's CompanyId,
          // for links that cannot carry one. It must stay ABOVE `:CompanyId`:
          // routes match in order, and `:CompanyId` would take `current` as an id.
          // `**` also matches nothing at all, so a bare `/client/current` arrives.
          {
            path: 'current',
            children: [
              {
                path: '**',
                canActivate: [ClientCompanyPlaceholderGuard],
                children: []
              }
            ]
          },
          {
            path: ':CompanyId',
            children: [
              {
                path: 'dashboard',
                component: ClientDashboardComponent
              },
              {
                path: 'vendors',
                children: [
                  {
                    path: 'my-vendor',
                    children: [
                      {
                        path: 'exempt-vendor/:ExemptVendorId',
                        children: vendorRouteArray
                      },
                      {
                        path: 'client-registered-vendor/:ClientRegisteredVendorId',
                        children: vendorRouteArray
                      },
                      {
                        path: ':VendorId',
                        children: vendorRouteArray
                      }
                    ]
                  },
                  {
                    path: 'vive-vendor',
                    children: [
                      {
                        path: ':VendorId',
                        component: VendorInformationComponent
                      }
                    ]
                  },
                  {
                    path: 'client-registered-vendor/:ClientRegisteredVendorId/edit',
                    component: AddEditClientRegisteredVendorComponent
                  },
                  {
                    path: 'exempt-vendor/:ExemptVendorId/edit',
                    component: AddEditExemptVendorComponent
                  },
                  {
                    path: 'client-registered-vendor/add',
                    component: AddEditClientRegisteredVendorComponent
                  },
                  {
                    path: 'exempt-vendor/add',
                    component: AddEditExemptVendorComponent
                  },
                  {
                    path: 'search/:view',
                    component: VendorSearchContainerComponent
                  },
                  {
                    path: ':view',
                    component: ClientVendorsComponent
                  }
                ]
              },
              {
                path: 'vendor-ratings',
                component: VendorRatingsComponent
              },
              {
                path: 'contracts',
                component: ContractsComponent
              },
              {
                path: 'contract',
                component: ContractComponent,
                children: [
                  {
                    path: 'addContract',
                    component: ContractAddContractComponent
                  },
                  {
                    path: ':ContractId/edit',
                    component: ContractAddContractComponent
                  },
                  {
                    path: ':ContractId/siteSelection',
                    component: ContractSiteSelectionComponent
                  },
                  {
                    path: ':ContractId/vendorSelection',
                    component: ContractVendorSelectionComponent
                  },
                  {
                    path: ':ContractId/review',
                    component: ContractReviewComponent
                  },
                  {
                    path: ':contractId',
                    component: ContractComponent
                  }
                ]
              },
              {
                path: 'sites',
                component: ClientSitesComponent
              },
              {
                path: 'site',
                children: [
                  {
                    path: 'addSite',
                    component: AddSiteComponent
                  },
                  {
                    path: ':SiteId/editSite',
                    component: EditSiteComponent
                  },
                  {
                    path: ':SiteId',
                    component: SiteComponent,
                    children: [
                      {
                        path: 'siteDetails',
                        component: SiteDetailsComponent
                      },
                      {
                        path: 'editSite',
                        component: EditSiteComponent
                      },
                      {
                        path: 'contacts',
                        component: SiteContactsComponent
                      },
                      {
                        path: 'vendors',
                        component: SiteVendorsComponent
                      },
                      {
                        path: 'vendor',
                        children: [
                          {
                            path: ':SiteVendorId',
                            children: [
                              {
                                path: 'files',
                                component: SiteVendorFilesComponent
                              }
                            ]
                          }
                        ]
                      },
                      {
                        path: 'vendors-validated',
                        component: SiteVendorsValidatedComponent
                      },
                      {
                        path: 'files',
                        component: SiteFilesComponent
                      },
                      {
                        path: 'users',
                        component: SiteUsersComponent
                      },
                      {
                        path: 'admin',
                        component: SiteAdminComponent
                      }
                    ]
                  }
                ]
              },
              {
                path: 'proposal-requests',
                component: QuicksourceComponent
              },
              {
                path: 'proposal-request',
                component: QuicksourceCreationComponent,
                children: ProposalRequestChildRoutes
              },
              {
                path: 'proposal-request/:ProposalRequestId/proposals',
                component: ProposalsComponent
              },
              {
                path: 'proposal-request/:ProposalRequestId/proposal-request-vendor/:ProposalRequestVendorId/proposal',
                component: ProposalComponent
              },
              {
                path: 'proposal-request/:ProposalRequestId/proposal-request-vendor/:ProposalRequestVendorId/proposal/:ProposalId',
                component: ProposalComponent
              },
              {
                path: 'proposal-request/:ProposalRequestId',
                component: QuicksourceCreationComponent,
                children: ProposalRequestChildRoutes
              },
              {
                path: 'proposal-request/:ProposalRequestId/:action',
                component: QuicksourceCreationComponent,
                children: ProposalRequestChildRoutes
              },
              {
                path: 'reports',
                component: ClientReportsComponent
              },
              {
                path: 'admin',
                component: ClientAdminComponent,
                children: [
                  {
                    path: 'users',
                    component: UsersComponent
                  },
                  {
                    path: 'user',
                    component: UserComponent
                  },
                  {
                    path: 'user/:UserId',
                    component: UserComponent
                  },
                  {
                    path: 'my-company',
                    component: ClientAdminMyCompanyComponent
                  },
                  {
                    path: 'spotlight-vendors',
                    component: ClientAdminSpotlightVendorsComponent
                  },
                  {
                    path: 'public-api-keys',
                    component: ClientAdminPublicApiKeysComponent
                  },
                  {
                    path: 'compliance-exempt-setup',
                    component: ClientAdminComplianceExemptSetupComponent
                  },
                  {
                    path: 'accounting',
                    component: ClientAdminAccountingComponent
                  },
                  {
                    path: 'accounting/apVendors',
                    component: ClientAdminAccountingAllApVendorsComponent
                  },
                  {
                    path: 'accounting',
                    children: [
                      {
                        path: ':ApConfigId',
                        component: ClientAdminAccountingSystemComponent
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: 'admin',
        component: AdminComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: 'dashboard',
            component: AdminDashboardComponent
          },
          {
            path: 'dashboard',
            children: [
              {
                path: 'businessVerificationApiErrors',
                component: BusinessVerificationApiErrorsComponent
              },
              {
                path: 'apSystems',
                component: ApSystemsComponent
              }
            ]
          },
          {
            path: 'admin',
            component: AdminAdminComponent,
            children: [
              {
                path: 'users',
                component: UsersComponent
              },
              {
                path: 'trades',
                component: AdminAdminTradesComponent
              },
              {
                path: 'change-log',
                component: ChangeLogComponent
              },
              {
                path: 'client-ap-configs',
                component: AdminAdminClientApConfigsComponent
              },
              {
                path: 'esign-templates',
                component: AdminAdminEsignTemplatesComponent
              },
              {
                path: 'sso-connections',
                component: AdminAdminSsoConnectionsComponent
              },
              {
                path: 'sso-connections/:connectionId',
                component: AdminAdminSsoConnectionComponent
              },
              {
                path: 'emails',
                component: AdminAdminEmailsComponent
              }
            ]
          },
          {
            path: 'notification-center',
            component: NotificationCenterComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'reports',
            component: ReportsComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'dashboards',
            component: AdminDashboardsComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'dashboards/:dashboardSlug',
            component: AdminDashboardsComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'run-vive',
            component: ComplianceComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'run-vive/client-vendor/:CompanyVendorId/client/:CompanyId/vendor/:VendorId/compliance-type/:CompanyComplianceTypeId/action/:action/insurance-review/insurance-agent/:InsuranceAgentId/coi',
            component: AddEditCOIComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'run-vive/client-vendor/:CompanyVendorId/client/:CompanyId/vendor/:VendorId/compliance-type/:CompanyComplianceTypeId/action/:action/insurance-review/insurance-agent/:InsuranceAgentId/coi/:InsuranceCertificateId',
            component: AddEditCOIComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'run-vive/client-vendor/:CompanyVendorId/client/:CompanyId/vendor/:VendorId/compliance-type/:CompanyComplianceTypeId/action/:action/insurance-review/insurance-agent/:InsuranceAgentId/coi/replace/:ReplaceCOIId',
            component: AddEditCOIComponent,
            canActivate: [AuthGuard]
          },
          {
            path: 'run-vive/client-vendor/:CompanyVendorId/client/:CompanyId/vendor/:VendorId/compliance-type/:CompanyComplianceTypeId/action/:action',
            component: ComplianceReviewComponent,
            children: [
              {
                path: 'business-review',
                component: ComplianceBusinessReviewComponent,
                canActivate: [AuthGuard]
              },
              {
                path: 'owner-review',
                component: ComplianceOwnerReviewComponent,
                canActivate: [AuthGuard]
              },
              {
                path: 'trade-review',
                component: ComplianceTradeReviewComponent,
                canActivate: [AuthGuard]
              },
              {
                path: 'insurance-review',
                component: ComplianceInsuranceReviewComponent,
                canActivate: [AuthGuard]
              },
              {
                path: 'final-review',
                component: ComplianceFinalReviewComponent,
                canActivate: [AuthGuard]
              },
              {
                path: 'documents-notes',
                component: VendorDocumentsNotesComponent,
                canActivate: [AuthGuard]
              },
              {
                path: 'sites',
                component: VendorSiteAssignmentComponent,
                canActivate: [AuthGuard]
              }
            ],
            canActivate: [AuthGuard]
          },
          {
            path: 'run-vive/client-vendor/:CompanyVendorId/client/:CompanyId/client-registered-vendor/:ClientRegisteredVendorId/action/:action',
            component: AdminComplianceClientRegisteredVendorsComponent,
            children: [
              {
                path: 'overview',
                component: AddEditClientRegisteredVendorComponent,
                canActivate: [AuthGuard]
              },
              {
                path: 'compliance',
                component: ClientRegisteredVendorComplianceComponent,
                canActivate: [AuthGuard]
              },
              {
                path: 'documents-notes',
                component: VendorDocumentsNotesComponent,
                canActivate: [AuthGuard]
              }
            ],
            canActivate: [AuthGuard]
          },
          {
            path: 'run-vive/client-vendor/:CompanyVendorId/client/:CompanyId/exempt-vendor/:ExemptVendorId/action/:action',
            component: AdminComplianceExemptVendorComponent,
            children: [
              {
                path: 'overview',
                component: AddEditExemptVendorComponent,
                canActivate: [AuthGuard]
              },
              {
                path: 'documents-notes',
                component: VendorDocumentsNotesComponent,
                canActivate: [AuthGuard]
              }
            ],
            canActivate: [AuthGuard]
          },
          {
            path: 'run-vive',
            redirectTo: 'run-vive',
            pathMatch: 'full'
          },
          {
            path: 'users',
            component: UsersComponent
          },
          {
            path: 'user',
            component: UserComponent
          },
          {
            path: 'user/:UserId',
            component: UserComponent
          },
          {
            path: 'clients',
            component: ClientsComponent
          },
          {
            path: 'clients',
            children: [
              {
                path: 'add',
                component: AddClientComponent
              }
            ]
          },
          {
            path: 'client/:CompanyId',
            component: AdminClientComponent,
            children: [
              {
                path: 'clientInfo',
                component: ClientInfoComponent
              },
              {
                path: 'complianceSettings',
                component: ComplianceSettingsComponent
              },
              {
                path: 'ap-configs',
                component: AdminClientApConfigsComponent
              },
              // {
              //   path: 'contacts',
              //   component: AdminClientContactsComponent
              // },
              {
                path: 'notes',
                component: AdminClientNotesComponent
              },
              {
                path: 'sites',
                component: AdminClientSitesComponent
              },
              {
                path: 'users',
                component: UsersComponent
              },
              {
                path: 'service-regions',
                component: AdminClientServiceRegionsComponent
              },
              {
                path: 'vendors',
                component: AdminClientVendorsComponent
              },
              {
                path: 'exempt-vendors',
                component: AdminClientExemptVendorsComponent
              },
              {
                path: 'client-registered-vendors',
                component: AdminClientClientRegisteredVendorsComponent
              },
              {
                path: 'admin',
                component: AdminClientAdminComponent
              }
            ]
          },
          {
            path: 'vendors',
            component: VendorsComponent
          },
          /* Need to add these components.
          {
            path: 'exempt-vendor'
          },
          {
            path: 'client-registered-vendor'
          }
          */
          {
            path: 'vendor/:VendorId',
            component: AdminVendorComponent,
            children: AdminVendorChildRoutes
          },
          {
            path: 'exempt-vendor/:ExemptVendorId',
            component: AdminVendorComponent,
            children: AdminVendorChildRoutes
          },
          {
            path: 'client-registered-vendor/:ClientRegisteredVendorId',
            component: AdminVendorComponent,
            children: AdminVendorChildRoutes
          }
        ]
      }
    ]
  },
  {
    path: 'proposal-request/:hyperlinkHash/documents',
    component: QuicksourceDownloadsComponent
  },
  // VPDW-4225: the legacy vendor registration/renewal wizard is gone — vendors
  // register and renew in vive-vendors. The paths are KEPT (emails already in
  // inboxes, bookmarks) and translated to their portal equivalent by
  // LegacyVendorWizardRedirectGuard, which redirects unconditionally rather than
  // reusing VendorPortalRedirectGuard — that guard passes traffic through when it
  // cannot decode a vendor session, which is precisely how an emailed
  // (unauthenticated) vendor kept reaching this wizard. No component, no children:
  // there is nothing left to render here. Deleting the paths outright would send
  // those links to the 404 wildcard instead.
  {
    path: 'vendor-registration/company/:CompanyIds/vendor/:VendorId/:paymentType',
    canActivate: [LegacyVendorWizardRedirectGuard],
    children: []
  },
  {
    path: 'vendor-registration/bundle/:BundleId/vendor/:VendorId/:paymentType',
    canActivate: [LegacyVendorWizardRedirectGuard],
    children: []
  },
  {
    path: 'vendor-registration/vendor-agreement/completed',
    canActivate: [LegacyVendorWizardRedirectGuard],
    children: []
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [VendorPortalRedirectGuard]
  },
  {
    path: 'login/forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'login/forgot-password/reset/:resetCode',
    component: ResetPasswordComponent
  },
  {
    path: 'login/:vendorSignUpCode/complianceType/:complianceType',
    component: LoginComponent,
    canActivate: [VendorPortalRedirectGuard]
  },
  {
    path: 'login/:vendorSignUpCode/claimCode/:claimCode/complianceType/:complianceType',
    component: LoginComponent,
    canActivate: [VendorPortalRedirectGuard]
  },
  {
    path: 'documents/rowcal/preferred-vendor-terms',
    component: RowcalPreferredVendorTermsComponent,
    canActivate: [RowcalTermsGuard],
    data: { companyId: config.getEnvironmentConfig().rowcalCompanyId }
  },
  {
    path: 'documents/client-service-agreement',
    component: ClientServiceAgreementComponent
  },
  { path: 'logout', component: LogoutComponent }
];

// While the session check is failing, SessionAvailableGuard sends every
// route to /unavailable, so /unavailable itself must stay outside it.
const routes: Routes = [
  { path: 'unavailable', component: SessionUnavailableComponent },
  {
    path: '',
    canActivateChild: [SessionAvailableGuard],
    children: guardedRoutes
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { paramsInheritanceStrategy: 'always' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
